import { REMINDER_DAYS, REMINDER_UI } from "@/data/manasikReminders";
import { toHijri, fromHijri, makkahTime, addDays } from "@/lib/hijri";
import { fill } from "@/lib/utils";

export const CORRECTION_KEY = "hijri_correction";
export const NOTIF_KEY = "manasik_notif";
export const readCorrection = () => {
  const v = parseInt(localStorage.getItem(CORRECTION_KEY) || "0", 10);
  return [-1, 0, 1].includes(v) ? v : 0;
};

const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

// Where we are in the Hajj season: today's Hijri date, whether we're inside 8–13 Dzulhijjah,
// the season year to schedule for, and the countdown to Tarwiyah.
export function hajjContext(correction = 0, now = new Date()) {
  const hijri = toHijri(now, correction);
  const inHajj = hijri.month === 12 && hijri.day >= 8 && hijri.day <= 13;
  const justEnded = hijri.month === 12 && hijri.day > 13;
  const seasonYear = justEnded ? hijri.year + 1 : hijri.year;
  const tarwiyah = fromHijri(8, 12, seasonYear, correction);
  const daysToTarwiyah = tarwiyah ? Math.round((startOfDay(tarwiyah) - startOfDay(now)) / 86400000) : null;
  return {
    hijri,
    phase: inHajj ? "hajj" : "before",
    justEnded,
    dayInfo: inHajj ? REMINDER_DAYS.find((d) => d.day === hijri.day) : null,
    seasonYear,
    daysToTarwiyah,
  };
}

export function formatHijri(h, tc) {
  const months = tc(REMINDER_UI.hijriMonths).split("|");
  return `${h.day} ${months[h.month - 1] || ""} ${h.year} ${tc(REMINDER_UI.hijriSuffix)}`.replace(/\s+/g, " ").trim();
}

// Timeline day chip that matches a Dzulhijjah day.
export const timelineDayFor = (hDay) => (hDay === 8 ? "8" : hDay === 9 ? "9" : hDay === 10 ? "10" : hDay >= 11 && hDay <= 13 ? "tasyrik" : null);

// Push payloads for the current/next season: eve (19:30) + morning (05:30), Makkah time, per day 8–13.
export function buildManasikReminders(tc, correction = 0, now = new Date()) {
  const { seasonYear } = hajjContext(correction, now);
  const items = [];
  for (const d of REMINDER_DAYS) {
    const date = fromHijri(d.day, 12, seasonYear, correction);
    if (!date) continue;
    const title = tc(d.title);
    const body = tc(d.body);
    const eve = makkahTime(addDays(date, -1), 19, 30);
    const morning = makkahTime(date, 5, 30);
    if (eve > now) items.push({ send_at: eve.toISOString(), title: fill(tc(REMINDER_UI.eveTitle), { title }), body: fill(tc(REMINDER_UI.eveBody), { body }), url: "/haji-timeline", day: d.day, slot: "eve" });
    if (morning > now) items.push({ send_at: morning.toISOString(), title: fill(tc(REMINDER_UI.todayTitle), { title }), body, url: "/haji-timeline", day: d.day, slot: "morning" });
  }
  return items;
}
